// MUST be the first import: patches antd v5 static methods (Modal.confirm,
// message.*, notification.*) to work under React 19. Without it these silently
// no-op. Remove only when migrating to antd v6 (native React 19 support).
import '@ant-design/v5-patch-for-react-19'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Suppress known Ant Design warnings (library-level issues with React 18/19)
const originalWarn = console.warn
const originalError = console.error
const suppressedWarnings = [
  'warnKey',
  'findDOMNode is deprecated',
  'Warning: React does not recognize',
  'initialValues',
  'onFinish',
]

console.warn = (...args) => {
  if (args[0] && typeof args[0] === 'string' && suppressedWarnings.some(w => args[0].includes(w))) {
    return
  }
  originalWarn.apply(console, args)
}

console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && suppressedWarnings.some(w => args[0].includes(w))) {
    return
  }
  originalError.apply(console, args)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
